import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface Tag {
  id: string;
  name: string;
  description: string;
  keywords: string[] | string;
}

export interface TagMapping {
  id: string;
  tag_id: string;
  company_id: string;
  subslug: string | null;
  explanation: string;
  sources: {
    version: string;
    url: string;
    text?: string;
  };
  created_at: string;
  tag: Tag | null;
}

interface TagsState {
  companyTags: TagMapping[];
  loading: boolean;
  error: string | null;
}

const initialState: TagsState = {
  companyTags: [],
  loading: false,
  error: null
};

const tagsSlice = createSlice({
  name: 'tags',
  initialState,
  reducers: {
    setCompanyTags: (state, action: PayloadAction<TagMapping[]>) => {
      state.companyTags = action.payload;
      state.loading = false;
      state.error = null;
    },
    setTagsLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setTagsError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearCompanyTags: (state) => {
      state.companyTags = [];
      state.loading = false;
      state.error = null;
    }
  }
});

export const { setCompanyTags, setTagsLoading, setTagsError, clearCompanyTags } = tagsSlice.actions;

export default tagsSlice.reducer;
